// src/pages/TimelinePage.tsx
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { useGetList } from "react-admin";
import React, { useEffect, useState } from "react";
import ReservationDetail from "@/garageManagment/reservations/ReservationDetail";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { Reservation } from "@/interface/entityInterface";

export default function TimelinePage() {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [row, setRow] = useState<Reservation | null>(null)
  const {data = []} = useGetList("auto-service-reservation/upcomings")

  const handleOpen = (e: React.MouseEvent, row: Reservation) => {
    e.preventDefault()
    e.stopPropagation()
    setOpen(true)
    setRow(row)
  } 

  return (
    <Card>
        <CardHeader className="flex items-center justify-between">
            <CardTitle>Upcoming Reservations</CardTitle>
            <Button onClick={() => navigate("/reservations")} className="py-1 px-2">View all</Button>
        </CardHeader>
      <CardContent>
        {data.length > 0 && data.map((item: Reservation) => (
          <div key={item.id} className="relative grid mt-3">
            {/* Dot */}
            {/* <div className="absolute -left-[10px] top-1.5 w-3 h-3 bg-primary rounded-full border-2 border-background"></div> */}

            {/* Content */}
            <div className="flex items-center justify-between">
              <div>
                <h4 className="font-medium text-base">{item.guest_user?.email}</h4>
                <p className="text-sm text-muted-foreground">{item?.date ? format(item?.date, "dd MMMM yyyy HH:mm") : "-"}</p>
              </div>
              <div className="mt-2">
                <Button onClick={(e: React.MouseEvent) => handleOpen(e, item)} size="sm" variant="outline">View</Button>
              </div>
            </div>
          </div>
        ))}
        {data?.length === 0 && <p className="text-center text-lg text-medium">No result</p>}
        <ReservationDetail open={open} setOpen={setOpen} row={row} />
      </CardContent>
    </Card>
  );
}
